(function($) {
    $(function() {
        // gallery
        $('.gallery').each(function( index ) {
            $(this).find('.gallery-icon a').attr('data-rel', 'lightcase:'+$(this).attr('id'));
        });

        //wp-block-gallery
        $('.wp-block-gallery').each(function( index ) {
            $(this).find('.blocks-gallery-item>figure>a').attr('data-rel', 'lightcase:'+index);
        });

        $('a[data-rel^=lightcase]').lightcase();
    });
} )( jQuery );